import { useMutation } from '@tanstack/react-query';
import { testEncryptionConnection } from '@/services/encryption/test-encryption-connection';
import { ConfigureEncryptionRequest } from '@/services/encryption/encryption-types';

export const useTestConnection = () => {
  return useMutation({
    mutationFn: (config: ConfigureEncryptionRequest) =>
      testEncryptionConnection(config),
  });
};
